(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoBachilleratoController', ReporteEvaluativoBachilleratoController);

    ReporteEvaluativoBachilleratoController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoBachilleratoService', 'ReporteEvaluativoBachilleratoRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoBachilleratoController ($scope, $state, $stateParams,ReporteEvaluativoBachilleratoService, ReporteEvaluativoBachilleratoRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.dosDecimales=dosDecimales;
		vm.nivelObtenido=nivelObtenido;
        vm.save=save;
        
        vm.print=print;
        
		function nivelObtenido(media){
			var mediaObtenida = parseFloat(media);
			var limiteInferiorSobresaliente = 3.72;
			var limiteSuperiorSatisfactorio = 3.71;
			var limiteInferiorSatisfactorio = 3.27;
			var limiteSuperiorSuficiente = 3.26;
			var limiteInferiorSuficiente = 2.94;
			var limiteSuperiorNecesitaMejorar = 2.93;
			var nivel = 'No aplica';
			
			if(mediaObtenida>=limiteInferiorSobresaliente){
				nivel = 'Sobresaliente';
			}else{
				if(mediaObtenida>=limiteInferiorSatisfactorio && mediaObtenida<=limiteSuperiorSatisfactorio ){
					nivel = 'Satisfactorio';
				}else{
					if(mediaObtenida>=limiteInferiorSuficiente && mediaObtenida<=limiteSuperiorSuficiente ){
						nivel = 'Suficiente';
					}else{
						if(mediaObtenida<=limiteSuperiorNecesitaMejorar){
							nivel = 'Necesita mejorar';
						}
					}
				}
			}
			return nivel;
		}
		
        function dosDecimales(valor){
			var numero = valor;
			return Number(numero).toFixed(2);
        }
        
		function round(valor){
			return Math.round(valor);
		}
				
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoBachilleratoRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoBachilleratoService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoBachilleratoService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;

            	if(vm.wrapper.tipoUser==1){
            		 $state.go('generarReporteBachillerato', 
            			{
            			 	idA: $stateParams.idA,
	             			idP: $stateParams.idP,
	             			idAnio: $stateParams.idAnio,
	             			idIndice: $stateParams.idIndice,
	             			ic: $stateParams.ic,
	                        iic: $stateParams.iic,
	             			tipoEvaluacion: $stateParams.tipoEvaluacion,
	             			idDependencia: $stateParams.idDependencia,
	             			nivell: $stateParams.nivell,
	             			modeloo: $stateParams.modeloo
            			} 
            				 
            		 ,{ reload: true });
            	}else{
            		if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteBachillerato', null, { reload: true });
                    }
            	}
//            }
        }
        

        function onSaveError () {
            vm.isSaving = false;
        }
 
    }
})();
